import { Pipe, PipeTransform } from '@angular/core';
import {TransactionType} from "../models/user-transaction.model";

@Pipe({
  name: 'transaction'
})
export class TransactionPipe implements PipeTransform {

  transform(value: TransactionType, ...args: unknown[]): string {
    if (value === TransactionType.ALL) {
      return 'همه';
    }
    if (value === TransactionType.TRADE) {
      return 'معامله';
    }
    if (value === TransactionType.DEPOSIT) {
      return 'واریز';
    }
    if (value === TransactionType.WITHDRAW) {
      return 'برداشت';
    }
    return value;
  }

}
